import React, { useEffect } from 'react';
import styled from 'styled-components';

import { FlexColumn } from '@make-software/cspr-design';
import { HeaderText } from '@block-explorer/ui';

const StyledMainContainer = styled.main(({ theme }) => ({
  width: '100%',
  maxWidth: theme.maxWidth,
}));

const Content = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: [
      '0px 16px 33px',
      '0px 32px 60px',
      '0px 56px 76px',
      '0px 0px 76px',
    ],
  })
);

export interface HomeLayoutProps {
  children?: React.ReactNode;
  title?: string;
  renderHeader?: () => React.ReactNode;
}

export const HomeLayout = (props: HomeLayoutProps) => {
  const { children, renderHeader, title } = props;

  useEffect(() => {
    document.title = `${title}`;
  }, [title]);

  return (
    <StyledMainContainer as="main" id="main-content" role="main" tabIndex={-1}>
      <Content>
        {renderHeader && <HeaderText size={2}>{renderHeader()}</HeaderText>}
        {children}
      </Content>
    </StyledMainContainer>
  );
};

export default HomeLayout;
